// extracted by mini-css-extract-plugin
export default {"hero":"HeroSection_hero__EPSxV"};